import { useState } from 'react';
import { t } from '@lingui/macro';

import Pencil from '@decisiv/iconix/lib/components/Pencil';

import Flex from '@decisiv/ui-components/lib/components/Flex';
import Button from '@decisiv/ui-components/lib/components/Button';

import FleetAdminAction from 'components/FleetAdminAction';
import useFleetAdminPermissions from 'utils/User/useFleetAdminPermissions';

import UpdateDepotModal from '../../UpdateDepotModal';

import type { ManagedDepotsType } from '../..';

interface CellProps {
  rowData: ManagedDepotsType;
}

export default function ActionsCell({ rowData }: CellProps) {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const fleetAdminPermissions = useFleetAdminPermissions();
  const editCapability = fleetAdminPermissions.capability(
    rowData.sentinelTeam?.oemSegment?.id,
    'canManageDepots',
  );

  return (
    <>
      <Flex flex={1} justifyContent="center" alignContent="center">
        <FleetAdminAction capability={editCapability}>
          {({ disabled }) => (
            <Button
              size="small"
              kind="secondary"
              icon={Pencil}
              text={t`Edit`}
              disabled={disabled}
              onClick={() => setIsModalOpen(true)}
            />
          )}
        </FleetAdminAction>
      </Flex>
      <UpdateDepotModal
        visible={isModalOpen}
        handleClose={() => setIsModalOpen(false)}
        depot={rowData}
      />
    </>
  );
}
